import { type HighlightResult } from 'highlight.js';

const hljsLinenumbers = ({ result, el }: { result: HighlightResult; el: Element }) => {
  if (!el.className.includes('line-numbers')) return;

  const lines = document.createElement('div');
  if (!result.value.includes('<span class="line-num">')) {
    lines.innerHTML = result.value.replace(/^/gm, '<span class="line-num"></span>');
  }
  el.replaceChildren(...lines.childNodes);
};

export default hljsLinenumbers;
